import React, { useState, useEffect } from 'react';
import Layout from '../components/Layout';
import Icon3D from '../components/Icon3D';
import { useTenant } from '../contexts/TenantContext';
import { useAuth } from '../contexts/AuthContext';
import { Package, ExternalLink, TrendingUp, Globe, ShoppingBag } from 'lucide-react';

const AdminGearPage = () => {
  const { tenant } = useTenant();
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);
  const [stats] = useState({
    totalClicks: 0,
    uniqueProducts: 0,
    topCountry: 'N/A'
  });

  useEffect(() => {
    document.title = `Gear & Equipment | Admin | ${tenant?.name || 'MedMCQ'}`;
  }, [tenant]);

  return (
    <Layout>
      <div className="max-w-7xl mx-auto px-4 py-8">

        {/* Header */}
        <div className="flex items-center gap-4 mb-8">
          <Icon3D icon={Package} colour="amber" size="md" />
          <div>
            <h1 className="text-2xl font-bold text-slate-900">Gear & Equipment Analytics</h1>
            <p className="text-slate-500 text-sm mt-0.5">Track affiliate link clicks from the Gear page</p>
          </div>
        </div>

        {/* Stats Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
          <div
            className="bg-white rounded-2xl border border-slate-200 p-5"
            style={{ boxShadow: 'var(--shadow-card)' }}
          >
            <div className="flex items-center gap-3 mb-2">
              <Icon3D icon={TrendingUp} colour="turquoise" size="sm" />
              <span className="text-sm font-medium text-slate-600">Total Link Clicks</span>
            </div>
            <div className="text-3xl font-bold text-slate-900">{stats.totalClicks}</div>
          </div>
          <div
            className="bg-white rounded-2xl border border-slate-200 p-5"
            style={{ boxShadow: 'var(--shadow-card)' }}
          >
            <div className="flex items-center gap-3 mb-2">
              <Icon3D icon={ShoppingBag} colour="purple" size="sm" />
              <span className="text-sm font-medium text-slate-600">Unique Products</span>
            </div>
            <div className="text-3xl font-bold text-slate-900">{stats.uniqueProducts}</div>
          </div>
          <div
            className="bg-white rounded-2xl border border-slate-200 p-5"
            style={{ boxShadow: 'var(--shadow-card)' }}
          >
            <div className="flex items-center gap-3 mb-2">
              <Icon3D icon={Globe} colour="green" size="sm" />
              <span className="text-sm font-medium text-slate-600">Top Country</span>
            </div>
            <div className="text-3xl font-bold text-slate-900">{stats.topCountry}</div>
          </div>
        </div>

        {/* Main Content */}
        <div
          className="bg-white rounded-2xl border border-slate-200 overflow-hidden"
          style={{ boxShadow: 'var(--shadow-card)' }}
        >
          <div className="p-5 border-b border-slate-100">
            <h2 className="font-bold text-slate-900">Affiliate Link Activity</h2>
            <p className="text-sm text-slate-500 mt-0.5">Click data from the Gear & Equipment page</p>
          </div>
          <div className="p-8 text-center">
            <div className="flex justify-center mb-4">
              <Icon3D icon={Package} colour="amber" size="lg" />
            </div>
            <h3 className="font-semibold text-slate-700 mb-2">No affiliate link data yet</h3>
            <p className="text-sm text-slate-400 max-w-sm mx-auto">
              Links clicked from the Gear page will appear here once affiliate tracking is enabled.
              Contact your developer to set up click tracking.
            </p>
          </div>
        </div>

      </div>
    </Layout>
  );
};

export default AdminGearPage;
